import { useNavigate } from 'react-router-dom'
import { Button } from '@bosch/react-frok'

import { titleSizes } from '@/constants'
import { CopyProps } from './types'

import './Copy.scss'

const Copy = ({
    headline,
    headlineSize = 4,
    buttons = [],
    alignment = '',
    headlineId,
    children,
    className = '',
}: CopyProps) => {
    const navigate = useNavigate()

    return (
        <div className={`copy ${className}`}>
            <div className={`a-text ${alignment}`} id={headlineId}>
                {headline && (
                    <div className={`title -size-${titleSizes[headlineSize as keyof typeof titleSizes]}`}>
                        {headline}
                    </div>
                )}
                {children}
                {buttons?.length > 0 &&
                    buttons.map((button) => {
                        return (
                            <div className="btn-wrapper" key={button.id}>
                                <Button
                                    label={button.label}
                                    onClick={() => {
                                        navigate(button.href)
                                    }}
                                    mode={button.type}
                                />
                            </div>
                        )
                    })}
            </div>
        </div>
    )
}

export default Copy
